import React from "react";
import * as hs from "@hlibs/react/hstyles";
import { HeaderFooterMainLayout } from "@hlibs/react-web/layouts";
import Header from "./Header";
import Footer from "./Footer";
import Box from "@mui/material/Box";

const defaultProps = {
  maxWidth: 1920,
  maxHeight: 1080,
  minWidth: 600,
};

const defaultStyles = {};

const drawerWidth = 271;

const MainLayout = (props) => {
  const { window, account, onLogout, onHome } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const mergedProps = hs.mergeProps(defaultProps, props);

  const styles = hs.mergeStyles(defaultStyles, mergedProps.style);

  const { children } = props;
  const container =
    window !== undefined ? () => window().document.body : undefined;
  const headerComponent =
    account.user === undefined ? (
      <></>
    ) : (
      <Header
        drawerWidth={drawerWidth}
        onToggle={handleDrawerToggle}
        container={container}
        mobileOpen={mobileOpen}
        user={account.user}
        onLogout={onLogout}
        onHome={onHome}
      />
    );
  const footerComponent = <Footer />;
  return (
    <HeaderFooterMainLayout
      header={headerComponent}
      footer={footerComponent}
      maxWidth={mergedProps.maxWidth}
      maxHeight={mergedProps.maxHeight}
      style={[styles]}
    >
      <Box sx={{ pb: 10 }}>{children}</Box>
    </HeaderFooterMainLayout>
  );
};

export default MainLayout;
